import { useEffect } from 'react'
import { useSession } from '../contexts/SessionContext'

// Preload functions - these will be defined when we implement the lazy components
const preloadFunctions: Record<string, () => void> = {}

// Register a preload function for a route
export function registerPreload(routeName: string, preloadFn: () => void) {
  preloadFunctions[routeName] = preloadFn
}

// Hook to preload critical routes based on user authentication status
export function useRoutePreloader() {
  const { currentUser, hasRole } = useSession()

  useEffect(() => {
    if (currentUser) {
      // Preload dashboard - critical for all authenticated users
      setTimeout(() => {
        preloadFunctions.dashboard?.()
      }, 100)

      // Preload profile page - frequently accessed
      setTimeout(() => {
        preloadFunctions.profile?.()
      }, 200)

      // Preload management pages for users with management roles
      if (hasRole('management')) {
        setTimeout(() => {
          preloadFunctions.properties?.()
          preloadFunctions.manageUsers?.()
        }, 300)
      }

      // Preload admin pages for admin+ roles
      if (hasRole('admin')) {
        setTimeout(() => {
          preloadFunctions.userAdministration?.()
        }, 400)
      }
    }
  }, [currentUser, hasRole])
}

// Manual preload function for on-demand loading
export function preloadRoute(routeName: string) {
  const preloadFn = preloadFunctions[routeName]
  if (preloadFn) {
    preloadFn()
  }
}

export default useRoutePreloader
